import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  constructor() { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token = String(localStorage.getItem("token"))

    const headers = new HttpHeaders({
      "Authorization": "Bearer " + token,
    })

    const reqClone = req.clone({
      headers: headers
    })

    return next.handle( reqClone );
  }
}
